$(document).ready(function (){
    $('.slickm1').slick({
        slidesToShow: 5,
        slidesToScroll: 2,
        autoplay: false,
        infinite: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        }],
    });

    $('.almadia-slick-authors').slick({
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: false,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        }],
    });




    $('.almadia-slick').slick({
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: false,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        }],
    });

    $('.slickm1-by-author').slick({
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        }],
    });

    $('.datepicker').datepicker({})
    $('.datepicker-format').datepicker({
        format: 'mm/dd/yyyy', // Formato de visualización en el datepicker
        onSelect: function(dateText, inst) {
            var formattedDate = $.datepicker.formatDate("yy-mm-dd", new Date(dateText));
            $(this).val(formattedDate);
        }
    })

})


